module.exports = __webpack_public_path__ + "img/confirm.1e324611.svg";